import React, { useEffect, useState, Component } from 'react';
import { Menu, X } from 'lucide-react';
import { motion, AnimatePresence } from 'framer-motion';
const LOGO_COLOR = 'https://cdn.magicpatterns.com/uploads/fdWnQMUp9fhE8KAVDmQakg/AZ_Logo_final_Colores.png';
const WA_LINK = `https://wa.me/50685316690?text=${encodeURIComponent('Quiero saber cuál plan se ajusta más a mi negocio.')}`;
export function Navbar() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  const navLinks = [{
    name: 'Beneficios',
    href: '#beneficios'
  }, {
    name: 'Método',
    href: '#metodo'
  }, {
    name: 'Testimonios',
    href: '#testimonios'
  }, {
    name: 'Precios',
    href: '#precios'
  }, {
    name: 'FAQ',
    href: '#faq'
  }];
  return <nav className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${isScrolled ? 'bg-[#050510]/90 backdrop-blur-md border-b border-purple-900/30 py-4' : 'bg-transparent py-6'}`} data-id="element-132">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 flex justify-between items-center" data-id="element-133">
        {/* Logo */}
        <a href="#" className="flex items-center gap-3 group" data-id="element-134">
          <img src={LOGO_COLOR} alt="Estrategias Digitales A-Z" className="h-10 md:h-12 w-auto object-contain drop-shadow-[0_0_8px_rgba(124,58,237,0.4)] group-hover:drop-shadow-[0_0_12px_rgba(217,70,239,0.6)] transition-all duration-300" data-id="element-135" />
        </a>

        {/* Desktop Navigation */}
        <div className="hidden md:flex items-center gap-8" data-id="element-136">
          {navLinks.map(link => <a key={link.name} href={link.href} className="text-sm font-medium text-gray-300 hover:text-white hover:text-shadow-glow transition-all duration-300 relative group" data-id="element-137">
              {link.name}
              <span className="absolute -bottom-1 left-0 w-0 h-0.5 bg-gradient-to-r from-purple-500 to-pink-500 group-hover:w-full transition-all duration-300" data-id="element-138" />
            </a>)}
          <a href={WA_LINK} target="_blank" rel="noopener noreferrer" className="px-6 py-2.5 rounded-full bg-gradient-to-r from-purple-600 to-pink-600 text-white font-bold text-sm tracking-wide hover:shadow-[0_0_20px_rgba(217,70,239,0.5)] transition-all duration-300 transform hover:scale-105" data-id="element-139">
            AGENDAR CITA
          </a>
        </div>

        {/* Mobile Menu Button */}
        <button className="md:hidden text-white p-2" onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)} aria-label="Toggle menu" data-id="element-140">
          {isMobileMenuOpen ? <X className="w-6 h-6" data-id="element-141" /> : <Menu className="w-6 h-6" data-id="element-142" />}
        </button>
      </div>

      {/* Mobile Menu */}
      <AnimatePresence data-id="element-143">
        {isMobileMenuOpen && <motion.div initial={{
        opacity: 0,
        height: 0
      }} animate={{
        opacity: 1,
        height: 'auto'
      }} exit={{
        opacity: 0,
        height: 0
      }} className="md:hidden bg-[#0a0a1a] border-b border-purple-900/30 overflow-hidden" data-id="element-144">
            <div className="px-4 py-6 space-y-4 flex flex-col" data-id="element-145">
              {navLinks.map(link => <a key={link.name} href={link.href} className="text-gray-300 hover:text-white text-lg font-medium py-2 border-b border-gray-800" onClick={() => setIsMobileMenuOpen(false)} data-id="element-146">
                  {link.name}
                </a>)}
              <a href={WA_LINK} target="_blank" rel="noopener noreferrer" className="mt-4 w-full text-center px-6 py-3 rounded-lg bg-gradient-to-r from-purple-600 to-pink-600 text-white font-bold hover:opacity-90 transition-opacity" onClick={() => setIsMobileMenuOpen(false)} data-id="element-147">
                AGENDAR CITA
              </a>
            </div>
          </motion.div>}
      </AnimatePresence>
    </nav>;
}